import { MSkeleton } from "src/ui/MSkeleton/MSkeleton"

export function BillingAddressLoading() {
  return <MSkeleton variant="rect" height={130} />
}
